import { Link } from "react-router-dom";
import { MapPin, Phone, Mail, Instagram, Linkedin, ArrowRight } from "lucide-react";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-[#1D3557] text-white" data-testid="footer">
      {/* Main Footer */}
      <div className="container-custom py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand Column */}
          <div className="lg:col-span-1">
            <div className="flex items-center gap-3 mb-6">
              <img 
                src="https://customer-assets.emergentagent.com/job_moreati-preview/artifacts/1lwcz7xi_Copie%20de%20nouveau%20logo%20moreati%20%281%29%20copie.png" 
                alt="MOREATI" 
                className="h-12 object-contain"
              />
            </div>
            <p className="text-stone-300 mb-6 leading-relaxed">
              Agence de marketing engagé au service des organisations. 
              Stratégie RSE, marketing engagé et communication durable.
            </p>
            <div className="flex gap-4">
              <a
                href="https://www.instagram.com/maud_agence_moreati"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center hover:bg-[#C65D47] transition-colors"
                data-testid="instagram-link"
              >
                <Instagram className="w-5 h-5" />
              </a>
              <a
                href="https://www.linkedin.com/company/agencemoreati/"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center hover:bg-[#C65D47] transition-colors"
                data-testid="linkedin-link"
              >
                <Linkedin className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Services Column */}
          <div>
            <h4 className="text-lg font-semibold mb-6" style={{ fontFamily: 'Fraunces, serif' }}>
              Nos Services
            </h4>
            <ul className="space-y-3">
              <li>
                <Link to="/piloter-strategie" className="footer-link flex items-center gap-2 group">
                  <ArrowRight className="w-4 h-4 opacity-0 -ml-6 group-hover:opacity-100 group-hover:ml-0 transition-all" />
                  Piloter sa stratégie
                </Link>
              </li>
              <li>
                <Link to="/fideliser-clients" className="footer-link flex items-center gap-2 group">
                  <ArrowRight className="w-4 h-4 opacity-0 -ml-6 group-hover:opacity-100 group-hover:ml-0 transition-all" />
                  Fidéliser ses clients
                </Link>
              </li>
              <li>
                <Link to="/developper-ventes" className="footer-link flex items-center gap-2 group">
                  <ArrowRight className="w-4 h-4 opacity-0 -ml-6 group-hover:opacity-100 group-hover:ml-0 transition-all" />
                  Développer ses ventes
                </Link>
              </li>
              <li>
                <Link to="/boutique" className="footer-link flex items-center gap-2 group">
                  <ArrowRight className="w-4 h-4 opacity-0 -ml-6 group-hover:opacity-100 group-hover:ml-0 transition-all" />
                  Valoriser sa marque
                </Link>
              </li>
            </ul>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-semibold mb-6" style={{ fontFamily: 'Fraunces, serif' }}>
              Liens Utiles
            </h4>
            <ul className="space-y-3">
              <li>
                <Link to="/boutique" className="footer-link">Boutique</Link>
              </li>
              <li>
                <Link to="/contact" className="footer-link">Contact</Link>
              </li>
              <li>
                <Link to="/login" className="footer-link">Mon Compte</Link>
              </li>
              <li>
                <a href="#" className="footer-link">Mentions Légales</a>
              </li>
              <li>
                <a href="#" className="footer-link">CGV</a>
              </li>
            </ul>
          </div>

          {/* Contact Column */}
          <div>
            <h4 className="text-lg font-semibold mb-6" style={{ fontFamily: 'Fraunces, serif' }}>
              Contact
            </h4>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <MapPin className="w-5 h-5 text-[#C65D47] flex-shrink-0 mt-0.5" />
                <div>
                  <p className="text-stone-300">Siège social</p>
                  <p>4 avenue du Mont Thabor</p>
                  <p>20090 Ajaccio, Corse</p>
                </div>
              </li>
              <li className="flex items-start gap-3">
                <MapPin className="w-5 h-5 text-[#8C9D78] flex-shrink-0 mt-0.5" />
                <div>
                  <p className="text-stone-300">Bureau</p>
                  <p>Cité Grossetti - Boulevard Albert 1er</p>
                  <p>20000 Ajaccio</p>
                </div>
              </li>
              <li>
                <a href="tel:+33751131092" className="flex items-center gap-3 footer-link hover:text-[#C65D47]">
                  <Phone className="w-5 h-5" />
                  07 51 13 10 92
                </a>
              </li>
              <li>
                <a href="mailto:maud@moreati.fr" className="flex items-center gap-3 footer-link hover:text-[#C65D47]">
                  <Mail className="w-5 h-5" />
                  maud@moreati.fr
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-white/10">
        <div className="container-custom py-6">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-stone-400">
            <p>
              © {currentYear} moreati.fr - Il est temps de prendre au sérieux nos rêves et d'en faire une stratégie - Création <a href="https://www.webisula.com/" target="_blank" rel="noopener noreferrer" className="text-[#8C9D78] hover:text-white transition-colors">WEBISULA</a>
            </p>
            <p>
              SASU MOREATI au capital de 5000€ - RCS Ajaccio N°913 223 079
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
